import { produce } from 'immer';
import type { MultiValueFilter } from '@/scopes/checkout/filterableCars/domain/types';

interface MultiValueFilterPayload {
  isChecked: string | boolean;
  value: string;
}

export function updateMultiValueFilter(payload: MultiValueFilterPayload) {
  return produce((filter: MultiValueFilter) => {
    if (payload.isChecked) {
      if (!filter.selectedFilters.includes(payload.value)) {
        filter.selectedFilters.push(payload.value);
      }
    } else {
      filter.selectedFilters = filter.selectedFilters.filter((item) => item !== payload.value);
    }
  });
}
